(function() {
  'use strict';
  
  angular
    .module('app.result', []);
  
})();